import axios from "../../service/index"
import React, { Component } from "react"
import {Form, Input, Select, Divider, message,  Switch, Button} from 'antd'
import UploadQiniu from '../../commponents/uploadQiniu/index'
import UploadVideo from '../../commponents/video/index'
import Wangeditor from '../../commponents/wangeditor/index'
import "./openclass.less"
const FormItem = Form.Item;
const {Option} = Select;
class createEnergize extends Component{
  constructor(props) {
		super(props)
    this.state = {
      modelTitle: '新建',
      subjectIcon: '',
      clickUrl: '',
      optionList: [],
      courseUrl: '',
      qiuniuUrl: '',
      url: '',
      queryId: '',
      courseType: '',
      isEdit: true,
      teacher: '',
      initViewNum: 0,
      detailInfo: {},
      type: 0,
      qiniuVideo: '',
      isIntroduct: true,
      classifyList: [],
      persistentId: '',
      isoutline: true,
      isresearch: true,
      isExperience: true,
      studyVideo: null,
      introductionContent: '',
      outlineContent: '',
      researchTeamContent: '',
      studyExperienceContent: '',
    }
  }
  componentDidMount() {
    this.getToken()
    this.subjectList()
    this.lassifyList()
    this.props.form.setFieldsValue({
			'publish': false
		})
    if(this.props.location.state?.id){
      this.setState({queryId: this.props.location.state.id, modelTitle: '编辑'}, () => {
        this.getInfo()
      })
    }
  }
  subjectList = () => {
    axios.get(`subjectController/subjects/2`).then(res => {
      if(res.data.code === '200'){
        this.setState({optionList: res.data.data})
      }else{
        message.error(res.data.msg)
      }
    })
  }
  lassifyList() {
		axios.post('dictionaryController/getDictionarysByPid', {pid: 94}).then( res => {
			if(res.data.code === '200') {
        console.log(res.data)
				let arr = res.data.data
				this.setState({
					classifyList: arr
				})
			}
		})
	}
  handleOk = (e) => {
    e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
        let videofileUrl = ''
        let fileName = ''
        let persistentId = ''
          videofileUrl = (values.studyVideo.url&&this.state.modelTitle === '编辑')?values.studyVideo.url:values.studyVideo[0].response.zmBosUrl?this.state.url+'/'+values.studyVideo[0].response.zmBosUrl:this.state.url+'/'+values.studyVideo[0].response.key
          fileName = this.state.modelTitle === '新建'?values.studyVideo[0].name:values.studyVideo.name && values.studyVideo.name ? values.studyVideo.name : values.studyVideo[0].name
          persistentId = (values.studyVideo.url &&this.state.modelTitle === '编辑')?values.studyVideo.persistentId: values.studyVideo[0].response.persistentId

        let params = {
          id: this.state.modelTitle === '编辑'?this.state.queryId:'',
          name: values.name,
          teacher: values.teacher,
          courseType: values.courseType,
          posterUrl: (values.posterUrl.url && this.state.modelTitle === '编辑')?values.posterUrl.url : this.state.qiuniuUrl+'/'+values.posterUrl.response.key,
          fileName: fileName||values.name,
          publish: values.publish === false?0:1,
          fileUrl: videofileUrl,
          persistentId: persistentId||'',
          initViewNum: values.initViewNum||0,
          introductionContent: values.introductionContent||'',
        }
        let url = this.state.modelTitle === '新建'?'/empowerCourseController/add': 'empowerCourseController/update'
        axios.post(url, params).then(res => {
          if(res.data.code === '200'){
            message.success(this.state.modelTitle+'成功')
            this.props.form.resetFields()
            localStorage.setItem('type', 'energiz')
            this.props.history.push('/subjectController')
            
          }else{
            message.error(res.data.msg)
          }
        })
      }
    })
  }
  getInfo = () => {
    axios.get(`empowerCourseController/info/${this.state.queryId}`).then(res => {
      // console.log(res.data.data)
      if(res.data.code === '200'){
        this.setState({
          // type: res.data.data.type,
          detailInfo: res.data.data,
          // subjectId: res.data.data.subjectId,
          teacher: res.data.data.teacher,
          initViewNum: res.data.data.initViewNum||0,
          courseType: res.data.data.courseType,
          introductionContent: res.data.data.introductionContent,
          subjectIcon: {
            uid: null,
            type: null,
            url: res.data.data.posterUrl,
            name: res.data.data.name
          },
          studyVideo: {
            uid: null,
            url: res.data.data.fileUrl,
            name: res.data.data.fileName,
            type: 'video/*',
            persistentId: res.data.data.persistentId
          }
        }, () => {
          this.props.form.setFieldsValue({
            'publish': res.data.data.publish === 0 ? false : true,
            'introductionContent': res.data.data.introductionContent,
          })
        })
        
      }else{
        message.error(res.data.msg)
      }
    })
  }
  
  getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
  componentWillUnmount() {
    this.setState = () => false;
 }
  getQiniuUrl = (v) => {
    this.setState({
			qiuniuUrl: v
		})
  }
  getQiniuUrl1 = v => {
  }
  getText = (v, i) => {
		this.props.form.setFieldsValue({
      [`${i}`]: v
		});
	}
  render() {
    const {modelTitle, subjectIcon,  introductionContent,  detailInfo,  studyVideo} = this.state
    const { getFieldDecorator } = this.props.form;
    return (
        <div className="create-subject">
          <div className="header-between">
          <span className="header-name">{modelTitle}赋能课程</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/subjectController')
              localStorage.setItem('type', 'energiz')
            }}>返回上一级</span>
          </div>
          <Divider />
          <Form labelCol={{ span: 3 }} wrapperCol={{ span: 12 }} onSubmit={this.handleOk}>
            <FormItem label={"课程名称"} key={0}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入课程名称!', }],
                initialValue:modelTitle==='编辑'? detailInfo.name: ''
              })(
                <Input placeholder='请输入课程名称' allowClear maxLength={50}/>
              )}
            </FormItem>
            <Form.Item label="课程封面" className="posterUrl" key={6}>
              {getFieldDecorator('posterUrl', {
                initialValue: modelTitle==='编辑'? subjectIcon: '',
                rules: [{ type: 'object', required: true, message: '请上传课程封面!' }],
              })(
                  <UploadQiniu getQiniuUrl ={this.getQiniuUrl } />
              )}
            </Form.Item>
            <FormItem label={"讲师"}>
              {getFieldDecorator('teacher', {
                rules: [{ required: true, message: '请输入讲师!', }],
                initialValue:modelTitle==='编辑'? detailInfo.teacher: ''
              })(
                <Input style={{width: "200px"}} placeholder='请输入讲师' allowClear maxLength={50}/>
              )}
            </FormItem>
            <FormItem label="导学资源">
              {getFieldDecorator('studyVideo', {
                rules: [{ required: true, message: '请上传视频!', }],
                initialValue:(modelTitle === '编辑'&&(studyVideo?.url))? studyVideo: ''
              })(
                  <UploadVideo checksType={'pass'} getQiniuUrl={this.getQiniuUrl1}></UploadVideo>
							  )
              }
            </FormItem>
            <FormItem label={"初始点击量"} key={2}>
              {getFieldDecorator('initViewNum', {
                rules: [{ required: true, message: '请输入点击量!', }],
                initialValue:modelTitle==='编辑'? detailInfo.initViewNum: 0
              })(
                <Input style={{width: "200px"}} placeholder='请输入点击量' allowClear maxLength={50}/>
              )}
            </FormItem>
            <Form.Item label="课程类型">
              {getFieldDecorator('courseType', {
                rules: [{ required: true, message: '请选择课程类型' }],
                initialValue:modelTitle === '编辑'? detailInfo.courseType: ''
              })(
                <div className="form-item-flex">
                  <Select
                    value={this.state.courseType}
                    placeholder="请选择课程类型"
                    onChange={(e) => {this.setState({courseType: e});this.props.form.setFieldsValue({'courseType': e})}}
                    style={{width: "200px",marginRight: '20px'}}
                  >
                    {this.state.classifyList.map(item=>{
                      return (<Option key={item.id+item.des} value={item.id}>{item.des}</Option>)
                    })}
                  </Select>
                </div>
              )}
            </Form.Item>
            <div>
            <FormItem label="课程介绍" style={{zIndex: '2'}}>
              {getFieldDecorator('introductionContent', {
                initialValue:modelTitle==='编辑'? introductionContent: ''
              })(
                 <Wangeditor content={introductionContent} getText={(e) => this.getText(e, 'introductionContent')} />
              )}
            </FormItem>
            
            </div>
            <FormItem label={"发布课程"}>
              {getFieldDecorator('publish', {
                valuePropName: 'checked'
              })(
                // <div>
                  <Switch  />
                //   <span style={{marginLeft: '20px'}}>课程发布后用户端可见</span>
                // </div>
              )}
            </FormItem>
            <FormItem>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<Button style={{ marginRight: '30px' }} onClick={() => {
								this.props.history.push('/subjectController')
                localStorage.setItem('type', 'energiz')
							}}>取消</Button>
							<Button type="primary" htmlType="submit">确定</Button>
						</div>
            </FormItem>
          </Form>
        </div>
    )
  }
}
export default Form.create()(createEnergize)